













import Vue from 'vue';
import SanityBlockContent from '@/components/SanityBlockContent.vue';

export default Vue.extend({
  name: 'TextWithHeadlinePanel',
  components: {
    SanityBlockContent,
  },
  props: {
    headline: {
      type: String,
      required: true,
    },
    text: {
      type: Array,
      required: true,
    },
    headlineSize: String,
    headlinePosition: String,
  },
});
